import React from 'react'
import GameContainer from '../GameContainer'
import Card from 'shared/Card'
import { Trophy } from 'app/icons'
import { Link } from '@reach/router'
import { PrimaryButton, SecondaryButton } from 'shared/Buttons'
import { usePlayGameContext } from '../playGameContext'
import { PlayGameMenu } from '../PlayGameMenu'
import PlayGamePlayer from '../Players/PlayGamePlayer'
import { Panel } from '../elements'
import Stack from 'shared/content-control/Stack'
import { useSessionContext } from 'components/sessions/sessionContext'
import { Star } from 'app/icons'
import { usePlayerQuery } from 'components/players/queries'
import PlayerCard from 'components/players/PlayerCard'
import { ButtonGroup } from 'react-bootstrap'
import { PlayJoystick, PodiumStar } from 'app/icons'
import { Button } from 'shared/Buttons'
import styled from 'styled-components'
import EvenlySpaced from 'shared/content-control/EvenlySpaced'
import { navigate } from '@reach/router'
const FinishedGame = () => {
  const { isGuest } = useSessionContext()
  return isGuest ? <GuestFinishedGame /> : <LoggedInFinishedGame />
}

const GuestFinishedGame = () => {
  const {
    startedGame: {
      players: { home },
    },
  } = usePlayGameContext()

  const result = usePlayerQuery()

  const player = result?.data?.player

  const rating = result?.data?.player?.stats?.rating

  if (!player) return <></>
  return (
    <GameContainer>
      <h1>⭐️ Get on our leaderboard! ⭐️</h1>
      <p style={{ margin: 0 }}>
        <Star style={{ marginRight: '1rem' }} />
        Based on your score, your rating would be {rating}/5 stars!
      </p>
      <p style={{ margin: 0 }}>
        <Star style={{ marginRight: '1rem' }} />
        Register for free to save your progress and appear on our{' '}
        <Link to="/leaderboard">leaderboard</Link>
      </p>
      <PlayerCard
        key={player.firstName}
        {...{
          isCurrentPlayer: true,
          ...player,
        }}
      />

      <ButtonGroup aria-label="Adversaries">
        <Button isPrimary={true} onClick={() => navigate('/register')}>
          <IconWrapper>
            <PodiumStar />
          </IconWrapper>
          Register
        </Button>
        <Button isPrimary={false} onClick={() => navigate('/create')}>
          <IconWrapper>
            <PlayJoystick />
          </IconWrapper>
          Keep playing
        </Button>
      </ButtonGroup>
      <PlayGamePlayer player={home} />
    </GameContainer>
  )
}

const IconWrapper = styled(EvenlySpaced.Row)`
  height: 3rem;
  margin: 1rem 0;
`

const LoggedInFinishedGame = () => {
  const {
    game,
    startedGame: {
      players: { home, away },
    },
  } = usePlayGameContext()

  const orderedPlayers = [...away, home].sort(
    (a, b) => a.totalScore > b.totalScore
  )

  return (
    <GameContainer>
      <PlayGameMenu game={game} />
      <Panel centered style={{ minHeight: '19rem' }}>
        <h1>
          Game over:{' '}
          {home.isGameWinner
            ? 'You win!'
            : home.isGameLoser
            ? 'you lose'
            : `It's a tie!`}
        </h1>
        <Card>
          <Card.Body>
            <Stack space="2">
              {orderedPlayers.map((itm) => (
                <Player
                  key={itm.id}
                  player={itm}
                  total={itm.totalScore}
                  isWinning={itm.isGameWinner}
                />
              ))}
              <Link to="/create">
                <PrimaryButton>Play again</PrimaryButton>
              </Link>
              your rating was updated
              <Link to="/leaderboard">
                <SecondaryButton>Check the Leaderboard</SecondaryButton>
              </Link>
            </Stack>
          </Card.Body>
        </Card>
      </Panel>
      <PlayGamePlayer player={home} />
    </GameContainer>
  )
}

const Player = ({ player: { username }, isWinning, total }) => (
  <div className="mb-">
    <span>
      {username}: {total} {isWinning ? <Trophy /> : ''}
    </span>
  </div>
)

export default FinishedGame
